import React from 'react'
import { FaExternalLinkAlt, FaMapPin, FaFilePdf, FaGlobe, FaYoutube } from 'react-icons/fa'
import { DOCUMENT_ICON_COLORS, DOCUMENT_ICON_SIZE, DOCUMENT_TYPE_LABELS, BOT_INTRO_MESSAGE, BOT_RESOURCE_LOCATION, BOT_ACTION_TEXTS } from '../../utils/constant'
import BotFeedback from './BotFeedback'

const BotMessage = ({ documents, explanation, messageId, botResponse, query, role, personId, roomId, feedbacks = [], showFeedback = true }) => {
  const getDocumentIcon = (contentType) => {
    const colorMap = {
      other: 'pdf',
      txt: 'article',
      youtube: 'youtube',
      default: 'article'
    }
    const iconColor = DOCUMENT_ICON_COLORS[colorMap[contentType] || colorMap.default]
    const iconSize = DOCUMENT_ICON_SIZE

    switch (contentType) {
      case 'other':
        return <FaFilePdf color={iconColor} size={iconSize} />
      case 'txt':
        return <FaGlobe color={iconColor} size={iconSize} />
      case 'youtube':
        return <FaYoutube color={iconColor} size={iconSize} />
      default:
        return <FaGlobe color={iconColor} size={iconSize} />
    }
  }

  const getDocumentType = (contentType) => {
    return DOCUMENT_TYPE_LABELS[contentType] || DOCUMENT_TYPE_LABELS.default
  }

  const getActionText = (contentType) => {
    return BOT_ACTION_TEXTS[contentType] || BOT_ACTION_TEXTS.default
  }

  const handleLinkClick = (url) => {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openURL) {
      window.webkit.messageHandlers.openURL.postMessage(url)
      return
    }
    window.open(url, '_blank')
  }
  
  const introMessage = explanation || BOT_INTRO_MESSAGE
  
  return (
    <div className="message-content">
      <div className="bot-intro">{introMessage}</div>

      {documents.map((doc, index) => (
        <div key={index} className="bot-resource-item">
          <div className="resource-header">
            {getDocumentIcon(doc.content_type)}
            <span className="resource-title">{doc.document_title}</span>
            <span className="resource-type">{getDocumentType(doc.content_type)}</span>
          </div>
          <div className="resource-source">
            <FaMapPin size={12} color="#d32f2f" />
            {doc.content_type === 'youtube' ? 'YouTube' : BOT_RESOURCE_LOCATION}
          </div>
          <div className="resource-action">
          <button type="button" onClick={() => handleLinkClick(doc.public_url)}> {getActionText(doc.content_type)} <FaExternalLinkAlt size={12} /> </button>
          </div>
        </div>
      ))}
      {showFeedback && (
        <BotFeedback
          messageId={messageId}
          botResponse={botResponse}
          query={query}
          role={role}
          personId={personId}
          roomId={roomId}
          feedbacks={feedbacks}
        />
      )}
    </div>
  )
}

export default BotMessage
